import React, { useEffect } from 'react';

import {
  BreadcrumbProvider,
  useScreenBreadcrumbsParams,
  createScreenRoute,
  Route,
  useLocation,
} from '@gogame/screens';
import { Sentry } from '@gogame/components';
import {
  groupsPreviewLink,
  conversionPagesLink,
  conversionPagesSearchParams,
} from 'scenes/Gallery/ConversionPages/navigation';

import ConversionPagesScreen from './screens/ConversionPagesScreen';
import ConversionGroupPreviewScreen from './screens/ConversionGroupPreviewScreen';

const id = 61;
const permission = 104;

const ConversionPages = () => {
  const [, setParams] = useScreenBreadcrumbsParams();
  const { search } = useLocation();
  useEffect(() => {
    const { filters, searchQuery } = conversionPagesSearchParams.parse(search);

    setParams({ filters, searchQuery });
  }, [search]);

  return (
  <Sentry.Routes>
      <Route
        path={`${groupsPreviewLink.path}/*`}
        element={
          <BreadcrumbProvider title={'loading...'}>
            <ConversionGroupPreviewScreen />
          </BreadcrumbProvider>
        }
      />
      <Route path={'/*'} element={<ConversionPagesScreen />} />
    </Sentry.Routes>
  );
};

export default createScreenRoute({
  id: id,
  permission: permission,
  title: 'Conversion Pages Gallery',
  link: conversionPagesLink,
  screen: <ConversionPages />,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/17776795458588-Conversion-Pages-Gallery',
});
